/** The five structured answers (docs/semantics.md, entry 7). Closed sets only. */
import { z } from 'zod'

export const VerifyOutput = z.object({
  /** Q1 — does the span, in context, express the proposition? */
  said: z.enum(['yes', 'partly', 'no']),
  /** Q2 — whom do the span's own words bind? */
  bound: z.enum(['speaker', 'speaker_org', 'recipient', 'third_party', 'nobody']),
  /** Q3 — acceptance. */
  accepted: z.enum(['self_bound', 'accepted_in_span', 'not_accepted', 'not_applicable']),
  /** Q4 — the force the span actually uses. */
  modality: z.enum(['will', 'try', 'intend', 'may', 'request', 'question', 'other']),
  /** Q5 — does the proposition stay inside the span? */
  scope_claimed: z.enum([
    'proposition_in_span',
    'proposition_adds_detail',
    'proposition_contradicts_span',
  ]),
  verdict: z.enum(['verified', 'disputed', 'rejected']),
  /** One plain sentence for Trace. */
  reason: z.string(),
})

export type VerifyOutputT = z.infer<typeof VerifyOutput>
